import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

export default function CallbackPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth.isLoading && auth.isAuthenticated) {
      navigate('/app', { replace: true });
    }
    if (!auth.isLoading && auth.error) {
      navigate('/', { replace: true });
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.error, navigate]);

  useEffect(() => {
    document.title = 'Signing in… | Remediation Analyzer';
  }, []);

  return (
    <Box
      role="status"
      aria-live="polite"
      aria-label="Signing you in, please wait"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 2,
        background: 'linear-gradient(135deg, #17134b 0%, #2d2875 100%)',
      }}
    >
      <CircularProgress size={48} sx={{ color: '#54FBF5' }} aria-hidden="true" />
      <Typography sx={{ color: '#fff', fontWeight: 600 }}>Signing you in…</Typography>
    </Box>
  );
}
